import { Input, cn } from "ui";
import { Search } from "lucide-react";

export interface ISearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  /** Forwarded to the underlying input for test/query hooks. */
  "data-testid"?: string;
  "aria-label"?: string;
}

/** A search field with a leading magnifier icon, used across the filter bars. */
export function SearchInput({
  value,
  onChange,
  placeholder,
  className,
  "data-testid": dataTestId,
  "aria-label": ariaLabel,
}: ISearchInputProps) {
  return (
    <div className={cn("relative", className)}>
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
      <Input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className="pl-9"
        data-testid={dataTestId}
        aria-label={ariaLabel}
      />
    </div>
  );
}
